module.exports = __webpack_public_path__ + "img/logo.4c87e412.png";